import {stateData, reduxState} from '../../values';

export const getBranches = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_branches,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateBranches = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_branches,
            payload:    data,
        })
    }
}